export enum DetailTableDataType {
	Document = 1,
	History = 2,
}
